// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"568":"a4620f9a","980":"2c56a223","984":"3be0c34b"}[chunkId] + ".chunk.js";
};